import React from "react";
var Loading = function (props) {
    var isFs = typeof props.isFullScreen === "undefined" ? true : props.isFullScreen;
    return (React.createElement("div", { className: "loading ".concat(props.className || "", " ").concat(isFs ? "loading--fs" : "loading--inline") },
        React.createElement("img", { className: "loading__img", src: require("../../images/loading.png").default, width: "180", height: "180" })));
};
export default Loading;
